import { useQuery } from '@tanstack/react-query';

import { fetchThemesByBrand, fetchThemesByProduct } from '@/entities/insight';
import type { PublicFilter } from '../../shared/public-filter/use-public-filter';
import type { DrillDownContext } from '../types';

type ThemeByContextParams = {
  queryId: string;
  startDate: string;
  endDate: string;
  context: DrillDownContext;
  publicFilter: PublicFilter;
};

const fetchThemesByContext = async (params: ThemeByContextParams, signal?: AbortSignal) => {
  if (params.context.type === 'brand') {
    return fetchThemesByBrand(
      {
        queryId: params.queryId,
        startDate: params.startDate,
        endDate: params.endDate,
        sentiment: params.context.sentiment,
        brand: params.context.name,
        publicFilter: params.publicFilter,
      },
      signal,
    );
  } else {
    return fetchThemesByProduct(
      {
        queryId: params.queryId,
        startDate: params.startDate,
        endDate: params.endDate,
        sentiment: params.context.sentiment,
        product: params.context.name,
        publicFilter: params.publicFilter,
      },
      signal,
    );
  }
};

export function useThemesByContext(params: ThemeByContextParams) {
  return useQuery({
    queryKey: [
      'themes-by-context',
      params.queryId,
      params.startDate,
      params.endDate,
      params.context,
      params.publicFilter,
    ],
    queryFn: ({ signal }) => fetchThemesByContext(params, signal),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}
